<template>
	<div id="app">
		<!-- 面包屑导航 -->
		<el-breadcrumb separator="/">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item><a href="/">分类管理</a></el-breadcrumb-item>
			<el-breadcrumb-item>分类列表</el-breadcrumb-item>
		</el-breadcrumb>

		<!-- 卡片视图区域 -->
		<el-card>
			<el-row :gutter="20">
				<el-col :span="4">
					<el-button type="primary" @click="addDialog = true">添加分类</el-button>
				</el-col>
			</el-row>

			<el-table :data="CateList" border stripe>
				<el-table-column type="index" label="#"></el-table-column>
				<el-table-column prop="catename" label="分类名称"></el-table-column>
				<el-table-column prop="img" label="封面图片">
					<template slot-scope="scope">
						<img :src="base + '/' +scope.row.img" alt=""
							style="width: 50px;height: 50px;">
					</template>
					<!-- </el-table-column> -->
				</el-table-column>

				<el-table-column label="操作" width="180px">
					<template slot-scope="scope">

						<el-button type="danger" icon="el-icon-delete" size="mini"
							@click="del(scope.row.id)"></el-button>

					</template>
				</el-table-column>

			</el-table>

			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
				:page-sizes="[2, 4, 6, 8]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</el-card>

		<!-- 添加用户得对话框 -->
		<el-dialog title="添加用户" :visible.sync="addDialog" width="40%" @close="addDialogClosed">
			<span>
				<el-form ref="addFormRef" :model="addForm" label-width="70px">
					<el-form-item label="分类名称">
						<el-input v-model="addForm.catename"></el-input>
					</el-form-item>
					<el-form-item label="图片上传">
						<el-upload class="upload-demo" :action="base+'/users/image'"
							:file-list="fileList" :on-success="success" list-type="picture">
							<el-button size="small" type="primary">点击上传</el-button>
							<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
						</el-upload>
					</el-form-item>
				</el-form>
			</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="addDialog = false">取 消</el-button>
				<el-button type="primary" @click="addCate">确 定</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import {
		getUserList,
		addUserList,
		selectUserList,
		editUserList,
		delUserList,
		CateList,
		Cateadd,
		Catedel
	} from '@/api/index.js'
	import {
		BASE_URL
	} from '../../config.js'
	export default {
		data() {
			return {
				CateList: [],
				selectUserObj: {},
				pageNum: 1,
				pageSize: 10,
				addForm: {
					catename: '',
					img: ''
				},
				editForm: {},
				addDialog: false,
				editDialog: false,
				total: 0,
				fileList: [],
				base:'',
			}
		},
		created() {
			this.getCateList();
			this.base=BASE_URL
		},
		methods: {
			async getCateList() {
				const {
					data: res
				} = await CateList({
					pageNum: this.pageNum,
					pageSize: this.pageSize,
				});

				this.CateList = res.data.list;
				this.total = res.data.total;

				// console.log(this.userList);
			},
			handleSizeChange(newsize) {
				this.pageSize = newsize;
				this.getCateList();
			},
			handleCurrentChange(newnum) {
				this.pageNum = newnum;
				this.getCateList();
			},
			addDialogClosed() {
				this.addForm.username = "";
				this.addForm.password = "";
			},
			success(response, fileList) {
							this.addForm.img = response.pic;
							console.log(this.addForm.img);
						},
			async addCate() {
				//请求我的接口
				const {
					data: res
				} = await Cateadd({
					catename: this.addForm.catename,
					img: this.addForm.img
				});
				if (res.code == 200) {
					this.$message.success('添加成功');
					this.getCateList();
					this.addDialog = false;
				} else {
					this.$message.success('添加失败');
				}
			},
			async del(id) {
				const {
					data: res
				} = await Catedel({
					id
				});
				if (res.code == 200) {
					this.$message.success('删除成功');
					this.getCateList();
				} else {
					this.$message.success('删除失败');
				}
			},
			successimg(response) {
				console.log(response);
				this.editForm.img = response.pic;
			}
		}
	}
</script>
<style scoped>
	.el-card {
		margin-top: 20px;
	}

	.el-row {
		margin-bottom: 20px;
	}
</style>